// constants.ts

export const NAME = 'pricingPage';